import { styled } from '@mui/material'

export const Root = styled('div')`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
`

export const Footer = styled('div')`
  margin: auto 0 0;
  width: 100%;
`
